<template>
  <div class="demo360">
    <div ref="container" class="photo-compare-container" id="photo-compare-container">
      <div style="width: 100%" ref="leftSide"></div>
      <div ref="rightSide"></div>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import config from '../../../settings/configEssilor';
import { mapState } from 'vuex';

export default {
  name: 'View360',
  data: function() {
    return {
      unwatchers: [],
      sceneLoading: false,
      stop: false,
      video: null,
      width: null,
      height: null,
      stage: {
        rightSide: {
          videoSprite: null,
          borderSprite: null,
          stage: null,
          renderer: null,
        },
        leftSide: {
          videoSprite: null,
          borderSprite: null,
          stage: null,
          renderer: null,
        },
      },
    };
  },
  methods: {
    getVideo(textureVideo, side) {
      //add video
      const videoSprite = new PIXI.Sprite.from(textureVideo);
      videoSprite.width = this.width;
      videoSprite.height = this.height;
      this.stage[side].videoSprite = videoSprite;
      return videoSprite;
    },
    getDashed(glasses, side) {
      //les tirets qui font le contour
      const borderSprite = new PIXI.Sprite.from(this.borderMask(glasses));
      borderSprite.width = this.width;
      borderSprite.height = this.height;
      this.stage[side].borderSprite = borderSprite;
      return borderSprite;
    },
    initScene(glasses, side) {
      //Create a Pixi Application
      const renderer = PIXI.autoDetectRenderer({ width: this.width, height: this.height });
      this.$refs[side].appendChild(renderer.view);

      // create the root of the scene graph
      const stage = new PIXI.Container();
      this.stage[side].stage = stage;
      this.stage[side].renderer = renderer;

      stage.interactive = true;

      //create sprite with mask
      const maskSprite = new PIXI.Sprite.from(this.blur(glasses));
      maskSprite.width = renderer.width;
      maskSprite.height = renderer.height;
      const maskContent = new PIXI.Sprite.from(this.video);
      maskContent.width = renderer.width;
      maskContent.height = renderer.height;
      maskContent.mask = maskSprite;
      stage.addChild(maskSprite);

      stage.addChild(this.getVideo(this.video, side));

      let filters = [];
      //create blur effect
      if (config.configStairs[glasses].blur) {
        const blurFilter = new PIXI.filters.BlurFilter();
        blurFilter.blur = 7;
        filters.push(blurFilter);
      }

      //create displacement filter from a texture image
      if (config.configStairs[glasses].distorsion) {
        const displacementSprite = new PIXI.Sprite.from(this.displacement(glasses));
        const displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
        displacementSprite.width = renderer.width;
        displacementSprite.height = renderer.height;
        displacementFilter.scale.y = config.configStairs[glasses].distorsion;
        displacementFilter.scale.x = 0;
        filters.push(displacementFilter);
        stage.addChild(displacementSprite);
      }

      //apply filter
      maskContent.filters = filters;

      stage.addChild(maskContent);
      if (this.showDash) stage.addChild(this.getDashed(glasses, side));

      //keep the video to pause and unpause while clicking
      this.$refs[side].firstChild.addEventListener('mousedown', this.clicked, false);
      this.$refs[side].firstChild.addEventListener('touchstart', this.clicked, false);
    },
    setVideo() {
      //create texture for video
      if (this.video) this.video.destroy(true);
      let textureVideo = new PIXI.Texture.from(this.fileName);
      textureVideo.baseTexture.resource.source.loop = true;
      this.video = textureVideo;
    },
    animate() {
      // render the stage
      if (!this.sceneLoading) {
        if (this.isCompareMode && this.stage['rightSide'].renderer)
          this.stage['rightSide'].renderer.render(this.stage['rightSide'].stage);
        if (this.stage['leftSide'].renderer) this.stage['leftSide'].renderer.render(this.stage['leftSide'].stage);
      }
      if (this.stage['leftSide'].renderer) requestAnimationFrame(this.animate);
    },
    clicked() {
      //this.stop = !this.stop;
      //if (!this.stop) this.animate();
      //pause and unpause the video
      this.video.baseTexture.resource.source.paused
        ? this.video.baseTexture.resource.source.play()
        : this.video.baseTexture.resource.source.pause();
    },
    computeSize() {
      let isFullScreen = false; // window.innerHeight === screen.height;
      const ratioGlassesMask = 16 / 9; // screen.width / screen.height;

      let width = isFullScreen ? window.innerWidth : window.innerWidth * (1 - 2 * 0.07); // 7vw

      let height = width / ratioGlassesMask;

      const maxHeight = isFullScreen ? window.innerHeight : window.innerHeight * (1 - 2 * 0.11); // 11vh

      // height = maxHeight;
      if (height > maxHeight) {
        height = maxHeight;
        width = height * ratioGlassesMask;
      }

      return { width, height };
    },
    blur(glasses) {
      return require(`../../../../public/demo/glass/blurmap-${glasses}_full_white.png`);
    },
    borderMask(glasses) {
      return require(`../../../../public/demo/glass/dash-${glasses}_full_white.png`);
    },
    displacement(glasses) {
      return require(`../../../../public/demo/glass/displacement-${glasses}.png`);
    },
    createCanvas() {
      this.setVideo();
      this.width = this.isCompareMode
        ? this.$refs.container.clientWidth / 2 - 1
        : this.$refs.container.clientHeight * (16 / 9);
      this.height = this.isCompareMode
        ? ((this.$refs.container.clientWidth / 2) * 9) / 16
        : this.$refs.container.clientHeight;
      this.initScene(this.leftGlasses, 'leftSide');
      if (this.isCompareMode) this.initScene(this.rightGlasses, 'rightSide');
    },
    cleanStages() {
      this.stage.leftSide.stage.destroy({
        children: true,
        baseTexture: true,
      });
      this.stage.leftSide.renderer.destroy(true);
      if (this.stage.rightSide.renderer) {
        this.stage.rightSide.stage.destroy({
          children: true,
          baseTexture: true,
        });
        this.stage.rightSide.renderer.destroy(true);
      }
      this.video.destroy();
      if (this.$refs['leftSide'].firstChild) this.$refs['leftSide'].removeChild(this.$refs['leftSide'].firstChild);
      if (this.$refs['rightSide'].firstChild) this.$refs['rightSide'].removeChild(this.$refs['rightSide'].firstChild);

      this.stage = {
        rightSide: {
          videoSprite: null,
          borderSprite: null,
          stage: null,
          renderer: null,
        },
        leftSide: {
          videoSprite: null,
          borderSprite: null,
          stage: null,
          renderer: null,
        },
      };
    },
  },
  computed: {
    ...mapState(['isCompareMode', 'showDashes']),

    fileName() {
      return require('../../../../public/demo/video/' + this.currentSituation.media.filename);
    },
    leftGlasses() {
      return this.$parent.LeftSelectedValue.id;
    },
    rightGlasses() {
      return this.$parent.RightSelectedValue.id;
    },
    currentSituation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    isCompareMode() {
      return this.$store.getters.isCompareMode;
    },
    showDash() {
      return this.$store.getters.showDashes;
    },
  },
  watch: {
    //update situation
    $route() {
      this.sceneLoading = true;
      this.setVideo();
      this.cleanStages();
      this.createCanvas();
      this.sceneLoading = false;
    },
    //update product
    '$parent.LeftSelectedValue': function() {
      this.$refs['leftSide'].removeChild(this.$refs['leftSide'].firstChild);
      this.initScene(this.leftGlasses, 'leftSide');
    },
    //update product
    '$parent.RightSelectedValue': function() {
      if (this.isCompareMode && this.$refs['rightSide'].firstChild) {
        this.$refs['rightSide'].removeChild(this.$refs['rightSide'].firstChild);
        this.initScene(this.rightGlasses, 'rightSide');
      }
    },
  },
  mounted() {
    this.stop = false;
    this.unwatchers.push(
      //Doted
      this.$store.watch(
        (state, getters) => getters.showDashes,
        () => {
          this.sceneLoading = true;
          if (!this.showDash) {
            this.stage.leftSide.borderSprite.destroy();
            if (this.isCompareMode) this.stage.rightSide.borderSprite.destroy();
          } else {
            if (this.isCompareMode) this.stage.rightSide.stage.addChild(this.getDashed(this.rightGlasses, 'rightSide'));
            this.stage.leftSide.stage.addChild(this.getDashed(this.leftGlasses, 'leftSide'));
          }
          this.sceneLoading = false;
        }
      ),
      //Comparaison désactiver ou activer
      this.$store.watch(
        (state, getters) => getters.isCompareMode,
        () => {
          this.sceneLoading = true;
          this.cleanStages();
          this.createCanvas();
          this.sceneLoading = false;
        }
      )
    );
    this.createCanvas();
    this.animate();
  },
  beforeDestroy() {
    this.pause = true;
    this.cleanStages();
    // Remove all watchers
    let unwatchMethod;
    while (this.unwatchers.length > 0) {
      // Get the "unwatch" methods...
      unwatchMethod = this.unwatchers.pop();
      // ... and call it!
      unwatchMethod();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo-compare-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
.container {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo360 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: stretch;
}
</style>
